export const ACESSO_SISTEMA_LOGIN_BEGIN = 'ACESSO_SISTEMA_LOGIN_BEGIN';
export const ACESSO_SISTEMA_LOGIN_SUCCESS = 'ACESSO_SISTEMA_LOGIN_SUCCESS';
export const ACESSO_SISTEMA_LOGIN_FAILURE = 'ACESSO_SISTEMA_LOGIN_FAILURE';
export const ACESSO_SISTEMA_LOGIN_DISMISS_ERROR = 'ACESSO_SISTEMA_LOGIN_DISMISS_ERROR';
export const ACESSO_SISTEMA_REGISTRAR_BEGIN = 'ACESSO_SISTEMA_REGISTRAR_BEGIN';
export const ACESSO_SISTEMA_REGISTRAR_SUCCESS = 'ACESSO_SISTEMA_REGISTRAR_SUCCESS';
export const ACESSO_SISTEMA_REGISTRAR_FAILURE = 'ACESSO_SISTEMA_REGISTRAR_FAILURE';
export const ACESSO_SISTEMA_REGISTRAR_DISMISS_ERROR = 'ACESSO_SISTEMA_REGISTRAR_DISMISS_ERROR';
export const ACESSO_SISTEMA_VALIDAR_ACESSO_TOKEN = 'ACESSO_SISTEMA_VALIDAR_ACESSO_TOKEN';
export const ACESSO_SISTEMA_LOGOUT_BEGIN = 'ACESSO_SISTEMA_LOGOUT_BEGIN';
export const ACESSO_SISTEMA_LOGOUT_SUCCESS = 'ACESSO_SISTEMA_LOGOUT_SUCCESS';
export const ACESSO_SISTEMA_LOGOUT_FAILURE = 'ACESSO_SISTEMA_LOGOUT_FAILURE';
export const ACESSO_SISTEMA_LOGOUT_DISMISS_ERROR = 'ACESSO_SISTEMA_LOGOUT_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/redux/constants.js